  export interface ProviderRequest {
    name: string;
    isWebProvider: boolean;
    isDigAdProvider: boolean;
    isChatProvider: boolean;
    isDrprovider: boolean;
    fileTokens?: string;
    isTradeInProvider: boolean;
    isServiceSchedulerProvider: boolean;
    code?: string;
    isReputationProvider: boolean;
    isSocialMediaProvider: boolean;
  }
  
  export interface GetProvidersResponse {
    providers: ProviderResponse[];
    totalCount: number;
    page: number;
  }
  
  export interface ProviderResponse {
    id: string;
    providerId: number;
    name: string;
    isWebProvider: boolean;
    isDigAdProvider: boolean;
    isChatProvider: boolean;
    isDRProvider: boolean;
    fileTokens?: string;
    isTradeInProvider: boolean;
    isServiceSchedulerProvider: boolean;
    code?: string;
    isReputationProvider: boolean;
    isSocialMediaProvider: boolean;
    logoUrl?: string;
    isActive: boolean;
    created?: string; // Using string type for date as ISO string
    modified?: string; // Using string type for date as ISO string
  }
  